import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Divider, message, Modal, Upload } from 'antd';
import React, { useState } from 'react'
import { FaEye } from 'react-icons/fa';
import pdfIcon from "../../assets/icons/pdf.svg";
import { FaRegFilePdf, FaFileExcel } from "react-icons/fa";
import { SlDocs } from "react-icons/sl";
import { Link } from 'react-router-dom';
const { Dragger } = Upload;

function DocumentUploader({ documents, setDocuments }) {
    const [showDocumentUpload, setShowDocumentUpload] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState(documents ? documents : []);
    const [selectUploadModal, setSelectUploadModal] = useState(false);

    const handledocumentUploadModal = () => {
        setShowDocumentUpload(true);
    };

    const handleCancleDocumetUpload = () => {
        setShowDocumentUpload(false);
    };


    const handleDeleteDocument = (file) => {
        setSelectedDocuments((prevDocs) =>
            prevDocs.map((doc) =>
                doc.name.split('/').pop() === file.name
                    ? doc.url
                        ? { ...doc, status: "removed" } // Mark as deleted
                        : null // Remove if no URL
                    : doc
            ).filter(Boolean)
        );
    };

    const uploadProps = {
        name: "file",
        multiple: true,
        accept: ".doc,.docx,.pdf,.xls,.xlsx",
        fileList: selectedDocuments.filter(doc => doc.status !== "removed")
        .map(file => ({
            uid: file.uid || file._id || file.name, // Ensure unique identifier
            name: file.name.split('/').pop(), // Extract clean name
            url: file.url || null, // Keep URL for preview
            status: file.status || "done", // Ensure status is correct
        })),
        customRequest({ file, onSuccess, onError }) {
            // Check file size (5MB max)
            if (file.size > 5 * 1024 * 1024) {
                message.error(
                    `${file.name} is larger than 5MB and cannot be uploaded.`
                );
                onError("File is too large");
                return;
            }

            handleDocumentUpload(file)
                .then(() => onSuccess(null, file))
                .catch(onError);
        },
        onRemove: handleDeleteDocument,
        onChange(info) {
            const { status } = info.file;
            if (status === "done") {
                console.log(`${info.file.name} uploaded successfully.`);
            } else if (status === "error") {
                console.error(`${info.file.name} upload failed.`);
            }
        },
        onDrop(e) {
            console.log("Dropped files", e.dataTransfer.files);
        },
    };

    const handleDocumentUpload = async (file) => {
        file.status = 'done'
        // console.log(file, "file");
        // console.log(file.status, "file status");
        // Update state correctly
        setSelectedDocuments((prevDocs) => [...prevDocs, file]);
    };

    // console.log(selectedDocuments, 'selectedDocuments');


    const handleSaveDocumetUpload = async () => {
        setDocuments(selectedDocuments)
        handleCancleDocumetUpload()
    };

    // const handleView = (url) => {
    //     window.open(url, "_blank");
    // };

    return (
        <div>
            <h2 className="text-2xl font-bold mb-4 mt-5">Documents</h2>
            <Button
                type="primary"
                icon={<UploadOutlined />}
                className="mt-4 md:mt-0 h-10 mb-3 text-[14px]"
                onClick={handledocumentUploadModal}
            >
                Upload/Manage Documents
            </Button>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {documents ?.filter(file => file.status !== "removed")?.map((file, index) => {

                    let IconComponent;
                    let imageSrc;
                    if (file.type === "application/pdf") {
                        // IconComponent = FaRegFilePdf;
                        imageSrc = pdfIcon
                    } else if (
                        file.type ===
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    ) {
                        IconComponent = FaFileExcel;
                    } else {
                        IconComponent = SlDocs;
                    }

                    return (
                        <div
                            key={index}
                            className="flex items-center justify-between p-4 border rounded-lg hover:border-blue-400 transition-colors bg-white"
                        >
                            <div className="flex items-center gap-3">
                                {imageSrc && <img src={imageSrc} alt="PDF" className="w-8 h-8" />}
                                {IconComponent && <IconComponent className="text-3xl text-gray-500 " />}
                                <p className="text-sm font-medium text-gray-700 truncate max-w-[150px]">
                                    {file?.name?.split('/').pop()}
                                </p>
                            </div>
                            {file?.url &&
                                <div className="flex gap-2">
                                    <Link
                                        // onClick={() => handleView(file?.url)}
                                        to={file?.url}
                                        target='_blank'
                                        className="flex items-center gap-2 px-3 py-2 text-white bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
                                    >
                                        <FaEye className="w-4 h-4" />
                                    </Link>
                                </div>
                            }
                        </div>
                    )
                })}
            </div>

            <Modal
                title="Upload Documents"
                visible={showDocumentUpload}
                onCancel={() => setSelectUploadModal(false)}
                footer={null}
                closable={false}
            >
                <Divider />
                <Dragger {...uploadProps}>
                    <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                    </p>
                    <p className="ant-upload-text">
                        Click or drag file to this area to upload
                    </p>
                    <p className="ant-upload-hint">
                        <strong>Maximum size: 5MB</strong>
                    </p>
                </Dragger>

                <div className="flex justify-end space-x-4 mt-6">
                    <Button
                        className="border-[#1777FF] text-[#1777FF] text-sm md:text-base"
                        onClick={handleCancleDocumetUpload}
                    >
                        DISCARD
                    </Button>
                    <Button
                        className="border-[#1777FF] text-[#1777FF] text-sm md:text-base"
                        onClick={handleSaveDocumetUpload}
                    >
                        Save
                    </Button>
                </div>
            </Modal>
        </div>
    )
}

export default DocumentUploader
